import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["beefCo"],
  _excluded2 = ["data", "beefCo"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
export var extractBeefCoDSL = function extractBeefCoDSL(_ref) {
  var _ref$data = _ref.data,
    oldBeefCo = _ref$data.beefCo,
    data = _objectWithoutProperties(_ref$data, _excluded),
    beefCo = _ref.beefCo,
    model = _objectWithoutProperties(_ref, _excluded2);
  return {
    beefCo: typeof beefCo !== 'undefined' ? beefCo : oldBeefCo,
    model: _objectSpread(_objectSpread({}, model), {}, {
      data: data
    })
  };
};
export { getLowCodePageMetrics, lowCodeMetricApi, yaMetricCounter, yaMetricsPublisher } from "./autometrics";
export { CrudeContext, CrudeLogic, CrudeMapper, CrudeMappingModule, CrudeProvider, withCrudeMappingRoot } from "./crude-mapping";
export * from "./enhancers";
export { enhancedConnect } from "./enhancedConnect";
export { withClassName } from "./hocs/withClassName";
export { withFlag } from "./hocs/withFlag";
export { headerAwareSmoothScroll } from "./utils/headerAwareSmoothScroll";